export default "/images/8925aa8b233d8e01a33de293041c71ae.avif";